import { useRef } from 'react';

export const useWillMount = (fn) => {
  const firstRender = useRef(true);
  if (firstRender.current) {
    fn();
    firstRender.current = false;
  }
};
